import { render, staticRenderFns } from "./UserDetailsManagerForm.vue?vue&type=template&id=e22cb264&"
import script from "./UserDetailsManagerForm.vue?vue&type=script&lang=js&"
export * from "./UserDetailsManagerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports